import { render } from "./KoruSortableBrowser.vue?vue&type=template&id=47dc16ee&ts=true"
import script from "./KoruSortableBrowser.vue?vue&type=script&lang=ts"
export * from "./KoruSortableBrowser.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__